import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMyPlan = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16 17C16.5523 17 17 17.4477 17 18C17 18.5523 16.5523 19 16 19H8C7.44772 19 7 18.5523 7 18C7 17.4477 7.44772 17 8 17H16ZM10 13C10.5523 13 11 13.4477 11 14C11 14.5523 10.5523 15 10 15H8C7.44772 15 7 14.5523 7 14C7 13.4477 7.44772 13 8 13H10Z",
			fill: "#DFCBF5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 16V19C21 21.2091 19.2091 23 17 23H7C4.79086 23 3 21.2091 3 19V5C3 2.79086 4.79086 1 7 1H9",
			stroke: "#DFCBF5",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 1C20.3137 1 23 3.6863 23 7C23 10.3137 20.3137 13 17 13C13.6863 13 11 10.3137 11 7C11 3.6863 13.6863 1 17 1Z",
			stroke: "#DFCBF5",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.5 7.5L16 9L19.5 5.5",
			stroke: "#DFCBF5",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgMyPlan;
